import React from 'react';
import { shape, func, string, arrayOf, number } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { capitalize } from '../../utils';
import { CardTab, List } from './payment-methods.styles';
import { Tab } from '../../atoms';

const PaymentMethodsTab = ({
  onChange,
  payments
}) => {
  const tabs = ['luizaCard', 'creditCard', 'pix', 'bankSlip'];
  return /*#__PURE__*/React.createElement(List, {
    "data-testid": "payments-list",
    onChange: onChange
  }, tabs.map(tab => {
    var _payments$tab;

    return !!(payments != null && (_payments$tab = payments[tab]) != null && _payments$tab.installmentPlans) && /*#__PURE__*/React.createElement(Tab, {
      value: payments[tab].id,
      key: `${tab}-tab`,
      "data-testid": `${tab}-tab`
    }, /*#__PURE__*/React.createElement(CardTab, null, /*#__PURE__*/React.createElement(Icon, {
      name: capitalize(tab)
    })));
  }));
};

PaymentMethodsTab.defaultProps = {
  payments: {}
};
process.env.NODE_ENV !== "production" ? PaymentMethodsTab.propTypes = {
  payments: shape({
    luizaCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        interestAmount: string,
        totalAmount: string
      }))
    }),
    creditCard: shape({
      id: string,
      installmentPlans: arrayOf(shape({
        installment: number,
        installmentAmount: string,
        interestAmount: string,
        totalAmount: string
      }))
    }),
    bankSlip: shape({
      id: string,
      discount: string,
      installmentAmount: string,
      interestAmount: string
    })
  }).isRequired,
  onChange: func.isRequired
} : void 0;
export default PaymentMethodsTab;